// WiFi Status (Configuration §216) is a single-byte bitmap on the
// shipping firmware (the SPEC originally said uint16 but the device
// emits a single byte — the mobile app reads it with getUbyte()).
// The decoder accepts either width defensively. Pure so it can be
// unit-tested without Web Bluetooth and reused by the web-app for log
// replay.
const FLAG_BITS = {
    off: 0x01,
    notConfigured: 0x02,
    notConnected: 0x04,
    cannotConnect: 0x08,
    connected: 0x10,
    onInternet: 0x20,
    onNetwork: 0x40,
};
// Highest priority first — picked in the SPEC's "ON_NETWORK > ON_INTERNET >
// CONNECTED > ..." order so the label reflects the most-positive state set.
const LABEL_PRIORITY = [
    [FLAG_BITS.onNetwork, 'ON_NETWORK'],
    [FLAG_BITS.onInternet, 'ON_INTERNET'],
    [FLAG_BITS.connected, 'CONNECTED'],
    [FLAG_BITS.cannotConnect, 'CANNOT_CONNECT'],
    [FLAG_BITS.notConnected, 'NOT_CONNECTED'],
    [FLAG_BITS.notConfigured, 'NOT_CONFIGURED'],
    [FLAG_BITS.off, 'OFF'],
];
export function decodeWiFiStatus(raw, timestamp = Date.now()) {
    const flags = {
        unknown: raw === 0,
        off: (raw & FLAG_BITS.off) !== 0,
        notConfigured: (raw & FLAG_BITS.notConfigured) !== 0,
        notConnected: (raw & FLAG_BITS.notConnected) !== 0,
        cannotConnect: (raw & FLAG_BITS.cannotConnect) !== 0,
        connected: (raw & FLAG_BITS.connected) !== 0,
        onInternet: (raw & FLAG_BITS.onInternet) !== 0,
        onNetwork: (raw & FLAG_BITS.onNetwork) !== 0,
    };
    let label = 'UNKNOWN';
    for (const [bit, name] of LABEL_PRIORITY) {
        if ((raw & bit) !== 0) {
            label = name;
            break;
        }
    }
    return { raw, flags, label, timestamp };
}
export function decodeWiFiStatusFromDataView(view, timestamp) {
    if (view.byteLength === 0) {
        throw new RangeError('WiFi Status payload is empty');
    }
    // Firmware sends a single byte (mobile app reads it as getUbyte). Older
    // SPEC notes mention uint16 little-endian; if a 2+ byte payload ever
    // arrives, decode it that way to stay forward-compatible.
    const raw = view.byteLength >= 2 ? view.getUint16(0, true) : view.getUint8(0);
    return decodeWiFiStatus(raw, timestamp);
}
//# sourceMappingURL=status.js.map